module.exports = __webpack_public_path__ + "static/media/tickets.9e8fbd0f.svg";